import type { CookieConsentConfig } from "vanilla-cookieconsent";

export default {
	categories: {
		necessary: {
			enabled: true, // this category is enabled by default
			readOnly: true, // this category cannot be disabled
		},
		help: {
			enabled: true,
		},
		analytics: {
			enabled: true,
		},
	},
	language: {
		default: "en",
		autoDetect: "browser",
		translations: {
			en: {
				consentModal: {
					title: "We use cookies",
					description:
						'We use cookies to enhance your browsing experience on our platform. By clicking "Accept all", you consent to our use of cookies as described in our privacy policy.',
					acceptAllBtn: "Accept all",
					acceptNecessaryBtn: "Reject all",
					showPreferencesBtn: "Manage preferences",
					footer: `
					<a rel="noopener" href="https://kultify.de/impressum" target="_blank">Impressum</a>
					<a rel="noopener" href="https://help.kultify.com/de/article/datenschutz-plattform-8pb3vd" target="_blank">Privacy Policy</a>
				`,
				},
				preferencesModal: {
					title: "Cookie Preferences",
					acceptAllBtn: "Accept all",
					acceptNecessaryBtn: "Reject all",
					savePreferencesBtn: "Save preferences",
					closeIconLabel: "Close modal",
					sections: [
						{
							title: "Cookie Usage Information",
							description:
								"Our platform uses cookies to improve functionality and user experience.",
						},
						{
							title: "Strictly Necessary Cookies",
							description:
								"These cookies are essential for the proper functioning of the platform and cannot be disabled. They enable basic functions such as page navigation and access to secure areas of the platform.",
							linkedCategory: "necessary",
						},
						{
							title: "Help Chat",
							description:
								"These cookies enable our customer support chat functionality powered by Crisp. They allow us to provide real-time assistance and remember your conversation history when you return to our site.",
							linkedCategory: "help",
						},
						{
							title: "Performance and Analytics",
							description:
								"These cookies collect information about how visitors use our platform. They help us understand which pages are most popular, how visitors navigate the site, and improve overall user experience.",
							linkedCategory: "analytics",
						},
						{
							title: "More Information",
							description:
								'For any questions regarding our cookie policy or your privacy choices, please see our <a href="https://help.kultify.com/de/article/datenschutz-plattform-8pb3vd" rel="noopener" target="_blank">Privacy Policy</a>.',
						},
					],
				},
			},
			de: {
				consentModal: {
					title: "Wir verwenden Cookies",
					description:
						'Wir verwenden Cookies, um Ihre Nutzererfahrung auf unserer Plattform zu verbessern. Durch Klicken auf "Alle akzeptieren" stimmen Sie unserer Verwendung von Cookies gemäß unserer Datenschutzrichtlinie zu.',
					acceptAllBtn: "Alle akzeptieren",
					acceptNecessaryBtn: "Alle ablehnen",
					showPreferencesBtn: "Einstellungen verwalten",
					footer: `
					<a rel="noopener" href="https://kultify.de/impressum" target="_blank">Impressum</a>
					<a rel="noopener" href="https://help.kultify.com/de/article/datenschutz-plattform-8pb3vd" target="_blank">Datenschutzrichtlinie</a>
				`,
				},
				preferencesModal: {
					title: "Cookie-Einstellungen",
					acceptAllBtn: "Alle akzeptieren",
					acceptNecessaryBtn: "Alle ablehnen",
					savePreferencesBtn: "Einstellungen speichern",
					closeIconLabel: "Modal schließen",
					sections: [
						{
							title: "Cookie-Nutzungsinformationen",
							description:
								"Unsere Plattform verwendet Cookies, um die Funktionalität und Benutzererfahrung zu verbessern.",
						},
						{
							title: "Unbedingt erforderliche Cookies",
							description:
								"Diese Cookies sind für das ordnungsgemäße Funktionieren der Plattform unerlässlich und können nicht deaktiviert werden. Sie ermöglichen grundlegende Funktionen wie Seitennavigation und Zugriff auf geschützte Bereiche der Plattform.",
							linkedCategory: "necessary",
						},
						{
							title: "Hilfe-Chat",
							description:
								"Diese Cookies ermöglichen unsere Kundenservice-Chat-Funktion, die von Crisp bereitgestellt wird. Sie erlauben uns, Ihnen Echtzeit-Unterstützung anzubieten und Ihren Gesprächsverlauf zu speichern, wenn Sie unsere Seite erneut besuchen.",
							linkedCategory: "help",
						},
						{
							title: "Leistung- und Analyse",
							description:
								"Diese Cookies sammeln Informationen darüber, wie Besucher unsere Plattform nutzen. Sie helfen uns zu verstehen, welche Seiten am beliebtesten sind, wie Besucher auf der Plattform navigieren und die allgemeine Benutzererfahrung verbessern.",
							linkedCategory: "analytics",
						},
						{
							title: "Weitere Informationen",
							description:
								'Bei Fragen zu unserer Cookie-Richtlinie oder Ihren Datenschutzoptionen lesen Sie bitte unsere <a href="https://help.kultify.com/de/article/datenschutz-plattform-8pb3vd" rel="noopener" target="_blank">Datenschutzrichtlinie</a>.',
						},
					],
				},
			},
		},
	},
} as CookieConsentConfig;
